import { render, staticRenderFns } from "./AppGridInBox.vue?vue&type=template&id=05a19342&scoped=true&"
import script from "./AppGridInBox.vue?vue&type=script&lang=js&"
export * from "./AppGridInBox.vue?vue&type=script&lang=js&"
import style0 from "./AppGridInBox.vue?vue&type=style&index=0&id=05a19342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a19342",
  null
  
)

export default component.exports